<script setup lang="ts">
import BasePopoverItem from "./BasePopoverItem.vue";
import ChatIcon20 from "../../../icons/ChatIcon20.vue";
import { locale } from "../../../../locale";
import { toggleChat, viewState } from "../../../../states/viewState";
const props = defineProps<{
  close: () => void;
}>();

const toggle = () => {
  toggleChat();
  props.close();
};
</script>
<template>
  <BasePopoverItem
    :text="
      viewState.rightBlockContent === 'chat'
        ? locale.moreList.hideChat
        : locale.moreList.showChat
    "
    @click.stop="toggle"
  >
    <ChatIcon20 />
  </BasePopoverItem>
</template>
